import React from "react";
import Row from "react-bootstrap/esm/Row";
import BatBlue from "../../img/bat-blue.png";
import trophy from "../../img/trophy.png";
import telecase from "../../img/telecast.png";
import { useNavigate } from "react-router-dom";
import Col from "react-bootstrap/esm/Col";
import obj from "../../Utils/helpers";
import { useTranslation } from "react-i18next";
import { isEmpty, upperCase } from "lodash";
import moment from "moment";
const RaceList = ({ countryCode, event,sportType }) => {
  const navigate = useNavigate();
  return (
    <div className="leagueBox mb-4">
      <div className="title">
        <Row>
          <Col md={6}>
            {countryCode == "undefined" ? "Other" : upperCase(countryCode)}
          </Col>
        </Row>
      </div>
      {event?.map((res) => {
        return (
          <div style={{ borderBottom: "1px solid #E8E8E8" }}>
            <div
              style={{
                padding: "4px 10px",
                paddingBottom: "0",
                fontWeight: "600",
              }}
            >
              {res?.items[0]?.eventName}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "5px",
                overflowX: "scroll",
                width: "100%",
              }}
            >
              {res?.items?.map((item) => {
                return (
                  <div
                  onClick={() =>
                    navigate(
                      `/match/${item?.eventId}/${item?.marketId}/${sportType}`
                    )
                  }
                    style={{
                      border: "1px solid #E8E8E8",
                      margin: "3px",
                      width: "55px",
                      padding: "5px",
                      cursor: "pointer",
                      color: item?.status == "in_play" ? "white" : "black",
                      background:
                        item?.status == "in_play" ? "#6BBD11" : "#E8E8E8",
                      borderRadius: "3px",
                      minWidth: "55px",
                      textAlign: "center",
                    }}
                  >
                     {moment(item?.MarketTime).format("HH:mm")}
                  </div>
                );
              })}{" "}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RaceList;
